var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-180.000000, -7479.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.9,7338.9h-3.2v-5.5c0-1.5-0.7-2.4-1.9-2.4c-1.3,0-2.1,0.9-2.1,2.4v5.5h-3.2v-10.3h3.2v1.2 c0,0,1-1.7,3.2-1.7c2.2,0,3.9,1.4,3.9,4.2V7338.9L143.9,7338.9z M130,7327c-1.1,0-1.9-0.9-1.9-1.9s0.9-1.9,1.9-1.9 c1.1,0,1.9,0.9,1.9,1.9C132,7326.1,131.1,7327,130,7327L130,7327z M128.1,7338.9h3.9v-10.3h-3.9V7338.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e09a8c12daaeda307a3c71a0968a9a0b.svg";
export { ForwardRef as ReactComponent };